// Redux & Action
import { useDispatch } from 'react-redux';
import { openAuthenApp } from "@core/redux/actions/auth/index";
import { useEffect, useState } from 'react';

// component
import { Grid } from '@mui/material';
import WrapperContainer from "views/components/WrapperContainer";
import Logo from "../../../components/Logo";
import Login from "./Login";
import Register from "./Register";
import Sidebar from "views/components/Sidebar";
import Credit from "views/components/Credit";
import NotificationSubscriptionMobile from 'views/components/NotificationSubscriptionMobile';
// import NavbarMenu from "./NavbarMenu";

export default function Navbar({ isUserLoggedIn, dataSetting }) {
    const dispatch = useDispatch();
    const [configInstallPWA, setConfigInstallPWA] = useState(null);
    const [notificationStatusMobile, setNotificationStatusMobile] = useState("load");
    const onSubmit = (action) => {
        dispatch(openAuthenApp({ tab: action, show: true }));
    }
    useEffect(() => {
        if (dataSetting !== null) {
            let url_domain = `${window.location.protocol}//${window.location.host}`;
            if (dataSetting?.cms?.section_notificaion_mobile_pwa === 1 || dataSetting?.cms?.section_notificaion_mobile_pwa === "1") {
                setConfigInstallPWA({
                    title: `แอพ ${dataSetting?.cms?.manifest_name}`,
                    body: `คลิกเพื่อติดตั้งแอพ ${dataSetting?.cms?.manifest_name}`,
                    text: dataSetting?.cms?.title_notificaion_pwa,
                    icon: dataSetting?.cms?.manifest_icon_lg,
                    data: {
                        url: url_domain,
                    },
                });
        
                setNotificationStatusMobile(true);
            }
            else {
                setNotificationStatusMobile(true);
            }
        }

    }, [dataSetting]);


    return (
        <>
        <div className="positionFixed topLeft zIndexLow navbar">
            <WrapperContainer className="contentWidth" maxWidth="xl">
                <Grid container alignItems="center" justifyContent="space-between" className="navbarHeight">
                    <Grid item>
                        <Logo></Logo>
                    </Grid>
                    <Grid item>
                        {
                            isUserLoggedIn() ?
                                <Grid container alignItems="center" justifyContent="flex-end" spacing={1}>
                                    <Grid item>
                                        <Credit></Credit>
                                    </Grid>
                                    <Grid item>
                                        <Sidebar showChildren={true} dataCms={dataSetting?.cms}></Sidebar>
                                    </Grid>
                                </Grid>
                                :
                                <Grid container alignItems="center" justifyContent="flex-end" spacing={1}>
                                    <Grid item>
                                        <Login onSubmit={onSubmit}></Login>
                                    </Grid>
                                    <Grid item>
                                        <Register onSubmit={onSubmit}></Register>
                                    </Grid>
                                    <Grid item>
                                        <Sidebar showChildren={true} dataCms={dataSetting?.cms}></Sidebar>
                                    </Grid>
                                </Grid>
                        }
                    </Grid>
                </Grid>
            </WrapperContainer>
            <WrapperContainer style={{ paddingLeft: "0px", paddingRight: "0px" }}>

{
                    (notificationStatusMobile !== "load" && (notificationStatusMobile !== null || notificationStatusMobile !== undefined || notificationStatusMobile !== "")) && (
                        configInstallPWA !== null && (
                            <NotificationSubscriptionMobile
                                setNotificationStatusMobile={setNotificationStatusMobile}
                                configInstallPWA={configInstallPWA}
                                notificationStatus={notificationStatusMobile === null || notificationStatusMobile === undefined || notificationStatusMobile === ""}
                            />
                        )
                    )
                }
    </WrapperContainer>

        </div>
            
        </>
    );
}